// extracted by mini-css-extract-plugin
export default {"image_wrap":"ImageCharacter_image_wrap__3F6e5","image":"ImageCharacter_image__qEDQT"};